export default "__VITE_ASSET__BfmBWJsv__"